<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <GoBack v-if="showBackButton" />
            <h3 class="d-inline heading">{{ account_name }}</h3>
          </div>
          <div class="heading-seperator"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <ul v-if="tasklists.length > 0">
            <li style="cursor: pointer" v-for="tasklist in tasklists" @click="displayTaskList(tasklist.id)">
              <div class="col-11 float-left font-15">{{ tasklist.name }}</div>
              <div class="col-1 float-left override-padding fa fa-angle-right" style="font-size: 20px !important;">&nbsp;</div>
            </li>
          </ul>
          <ul v-else>
            <li v-if="loading == false" style="border: 0;" class="noitems-custom-msg">
              No tasklist assigned
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import axios from 'axios';
import router from '../../router/index.js';

export default {
        data() {
          return {
            task_id: '',
            tasklists: [],
            loading: false,
            account_name: '',
            showBackButton: false,
          }
        },
        components: {
          UserMenu,
          GoBack
        },
        methods: {
          getMenteeAccountTasklists() {
            axios.get('/mentee/account/tasklists', {
              params: {
                account_id: this.$route.params.account_id,
              }
            })
            .then(response =>  {
              this.loading = false;
              this.tasklists = response.data.tasklist;
              this.account_name = response.data.account_name;
            })
            .catch(function(error) {
              console.log(error);
            });
          },
          displayTaskList(task_id) {
            var account_id = this.$route.params.account_id;
            this.navigate("/student-account-tasklist-details/" + account_id + "/" + task_id);
          },
          navigate(path) {
        	  router.push(path);
        	},
        },
        created: function () {
          this.loading = true;
          axios.get('/mentee/account_lists', {

          })
          .then(response =>  {
            if(response.data.length > 1) {
              this.showBackButton = true;
            }
          })
          .catch(function(error) {

          });
          this.getMenteeAccountTasklists();
        }
    }

</script>

<style scoped>
  .container-wrapper ul {
    list-style: none;
    padding: 0px;
  }
  .container-wrapper ul li {
    padding: 10px 5px;
    border: 1px solid #CCC;
    margin-top: 10px;
    float: left;
    width: 100%;
  }
  label {
    width: 100%;
    font-size: 15px;
  }
  .custom-select {
    font-size: 14px;
    height: 38px;
  }
  hr {
    margin: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/student_account_tasklists.vue